import { TypeSelectDropdownFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import SelectDropdown from './SelectDropdown'

const mapSelectDropdownItems = (props) => {
  return props.fields?.selectDropdownItems.map((selectDropdownItem) => ({
    id: selectDropdownItem.sys.id,
    itemText: selectDropdownItem.fields?.selectItemText,
    itemValue: selectDropdownItem.fields?.selectItemValue,
  }))
}

const defaultValue = (props) => {
  return props.fields?.selectDropdownItems[0].itemValue
}

const ContentfulSelectDropdown = withContentful<TypeSelectDropdownFields>(SelectDropdown, {
  selectDropdownItems: mapSelectDropdownItems,
  defaultValue: defaultValue,
})

export default ContentfulSelectDropdown
